<template>
	<v-card v-if="examination" class="bowel-cleanse-forms">
    <v-layout>
      <v-flex xs3>
        <indication-input
          :data ="getIndicationValues()"
          hide-details
          @change="handleFieldChange"
        ></indication-input>
      </v-flex>
      <v-flex xs9>
        <v-container grid-list-lg class="pa-0">
        <v-layout>
          <v-flex xs4>
            <inspection-instrument-input
              :data="examination.examination.inspection_instrumentID"
              hide-details
              @change="$emit('change', { field: 'inspection_instrumentID', event: $event } )"
            ></inspection-instrument-input>
            <wash-instrument-input
              :data="examination.examination.wash_instrumentID"
              hide-details
              @change="$emit('change', { field: 'wash_instrumentID', event: $event } )"
            ></wash-instrument-input>
          </v-flex> 
          <v-flex xs4>
            <preparation-time-input
              :data="examination.examination.preparationTime"
              hide-details
              @change="$emit('change', { field: 'preparationTime', event: $event } )"
            ></preparation-time-input>
            <clean-scale-input
              :data="examination.examination.cleanScale"
              hide-details
              @change="$emit('change', { field: 'cleanScale', event: $event } )"
            ></clean-scale-input>
          </v-flex>
          <v-flex xs4>
            <insertion-level-input
              :data="examination.examination.insertionLevel"
              hide-details
              @change="$emit('change', { field: 'insertionLevel', event: $event } )"
            ></insertion-level-input>
            <clean-scale-input-after
              :data="examination.examination.cleanScaleAfter"
              hide-details
              @change="$emit('change', { field: 'cleanScaleAfter', event: $event } )"
            ></clean-scale-input-after>    
          </v-flex>
          <v-flex xs4>
            <insertion-length-input
              :data="examination.examination.insertionLength"
              hide-details
              @change="$emit('change', { field: 'insertionLength', event: $event } )"
            ></insertion-length-input>
            <incomplete-due-to-input
              :data="examination.examination.incompleteDue"
              :examinationTypeID="examination.examination.examination_typeID"
              hide-details
              @change="$emit('change', { field: 'incompleteDue', event: $event } )"
            ></incomplete-due-to-input>
          </v-flex>
        </v-layout>
        <time-inputs-group
          :data="examination.examination"
          hide-details
          @change="$emit('change', $event)"
        ></time-inputs-group>
         </v-container>
      </v-flex>
      <v-flex xs2>
        <div class="label-text">Additional Remarks</div>
        <v-textarea
          no-resize
          outline
          height="133px"
          row-height="20px"
          v-model="additionalRemarksValue"
          class="additional-remarks"
          @change="$emit('change', { field: 'additionalRemarks', event: $event } )"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <br/>
    <v-layout>
      <v-flex xs4>
        <v-layout>
          <v-flex xs6 pl-0>
            <antispasmodic-input
              :data="getAntispasmodicValues()"
              @change="handleFieldChange"
              hide-details
            ></antispasmodic-input>
          </v-flex>
          <v-flex xs6>
            <sedative-input-group
              :examinationID="examinationID"
              :sedatives="sedatives"
              :sedativesList="examination.sedatives"
              :sedativeOther="examination.examination.sedativeOther"
               @change="handleFieldChange"
            ></sedative-input-group>
          </v-flex>
        </v-layout>
        <br/>
        <v-layout>
          <complication-input
            :data="getComplicationValues()"
            @change="handleFieldChange"
            hide-details
          ></complication-input>
        </v-layout>
      </v-flex>
      <v-flex xs4>
       <preparation-agent-input
          :data="getPreparationAgentValues()"
          @change="handleFieldChange"
          hide-details
        ></preparation-agent-input>
      </v-flex>
      <v-flex xs4>
        <antiplatelet-input
          :data="getAntiplateletValues()"
          @change="handleFieldChange"
          hide-details
        ></antiplatelet-input>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import forms from '@/utils/forms'
  import TimeInputsGroup from '@/components/TimeInputsGroup.vue'
  import SedativeInputGroup  from '@/components/bowelCleanseForms/SedativeInputGroup.vue'
  import InspectionInstrumentInput from '@/components/bowelCleanseForms/InspectionInstrumentInput.vue'
  import WashInstrumentInput from '@/components/bowelCleanseForms/WashInstrumentInput.vue'
  import CleanScaleInput from '@/components/bowelCleanseForms/CleanScaleInput.vue'
  import InsertionLevelInput from '@/components/bowelCleanseForms/InsertionLevelInput.vue'
  import IncompleteDueToInput from '@/components/bowelCleanseForms/IncompleteDueToInput.vue'
  import IndicationInput from '@/components/bowelCleanseForms/IndicationInput.vue'
  import PreparationTimeInput from '@/components/bowelCleanseForms/PreparationTimeInput.vue'
  import AntispasmodicInput from '@/components/bowelCleanseForms/AntispasmodicInput.vue'
  import PreparationAgentInput from '@/components/bowelCleanseForms/PreparationAgentInput.vue'
  import AntiplateletInput from '@/components/bowelCleanseForms/AntiplateletInput.vue'
  import ComplicationInput  from '@/components/bowelCleanseForms/ComplicationInput.vue'
  import CleanScaleInputAfter from '@/components/bowelCleanseForms/CleanScaleInputAfter.vue'
  import InsertionLengthInput from '@/components/bowelCleanseForms/InsertionLengthInput.vue'


	export default {
		name: 'ColonReportBowelCleanseForms',

    components: {
      TimeInputsGroup,
      SedativeInputGroup,
      InspectionInstrumentInput,
      WashInstrumentInput,
      CleanScaleInput,
      InsertionLevelInput,
      IncompleteDueToInput,
      IndicationInput,
      PreparationTimeInput,
      AntispasmodicInput,
      PreparationAgentInput,
      AntiplateletInput,
      ComplicationInput,
      CleanScaleInputAfter,
      InsertionLengthInput,
    },

		props: {
      examination: {
        type: Object,
        required: true
      },

      sedatives: {
        type: Array,
      }
    },

		data () {
			return {
        timeList: [
          'insertionTime',
          'proximalColonWithTime',
          'withdrawTime',
          'totalExamTime'
        ],
        EXAMINATION_TYPE_OF_GASTROSCOPY: 1
			}
		},

		computed: {
      ...mapGetters('examinations', [
        'getSedativeList'
      ]),

      examinationID () {
        return this.examination.examination['id']
      },
      reportType () {
        return this.examination.examination.examination_typeID
      },
      additionalRemarksValue : {
        get () { return this.examination.examination.additionalRemarks },
        set (val) { this.examination.examination.additionalRemarks = val }
      },
		},

		methods: {
      getIndicationValues() {
        const { indication, indicationOther } = this.examination.examination
        return { indicationIDs: indication, indicationOther }
      },
      getAntispasmodicValues() {
        const { antispasmodicHave, antispasmodicID, antispasmodicOther, antispasmodicReason } = this.examination.examination
        return { antispasmodicHave: Number(antispasmodicHave) || null, antispasmodicIDs: antispasmodicID, antispasmodicOther, antispasmodicReason }
      },
      getPreparationAgentValues() {
        const { clean_medID, clean_medOther } = this.examination.examination
        return { clean_medIDs: clean_medID, clean_medOther }
      },
      getAntiplateletValues() {
        const { antiplateletID, antiplateletOther, antiplateletStopDays } = this.examination.examination
        return { antiplateletIDs: antiplateletID, antiplateletOther, antiplateletStopDays }
      },
      getComplicationValues () {
        const { complication, complicationOther } = this.examination.examination
        return { complicationIDs: complication, complicationOther }
      },
      handleFieldChange({ field, event }) {
        this.$emit('change', { field, event } )
      }
    }
	}
</script>

<style lang="scss">
  @import '@/styles/components/bowelCleanseForms.scss';
</style>